var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickMark = function SvgTickMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TickMark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.733A7.733 7.733 0 1 0 8 .267a7.733 7.733 0 0 0 0 15.466Z",
    fill: "#1D9428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47 11.219 4.657 9.447a.409.409 0 0 1 0-.586l.601-.587a.432.432 0 0 1 .602 0L6.94 9.33l3.027-4.602a.431.431 0 0 1 .587-.125l.715.45a.409.409 0 0 1 .128.574l-3.585 5.452a.88.88 0 0 1-1.342.14Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TickMark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTickMark;